export default {
  "name": "Clips",
  "assets": [{
    "file": "wickobjects/button.wickobj",
    "name": "Button",
    "icon": "icons/button.png",
  },{
    "file": "wickobjects/vcam.wickobj",
    "name": "Vcam (Beta)",
    "icon": "icons/vcam.png",
  },{
    "file": "wickobjects/multiframeclip.wickobj",
    "name": "Multi-Frame Clip",
    "icon": "icons/multiframeclip.png",
  },{
    "file": "wickobjects/checkbox.wickobj",
    "name": "Checkbox",
    "icon": "icons/checkbox.png",
  },{
    "file": "wickobjects/keyboardcontrol.wickobj",
    "name": "Keyboard Controlled Character",
    "icon": "icons/keyboardcharacter.png",
  },{
    "file": "wickobjects/link.wickobj",
    "name": "URL Link",
    "icon": "icons/link.png",
  },{
    "file": "wickobjects/slider.wickobj",
    "name": "Slider",
    "icon": "icons/slider.png",
  },{
    "file": "wickobjects/textinput.wickobj",
    "name": "Text Input",
    "icon": "icons/textinput.png",
  }],
}
